export default __webpack_public_path__ + "static/media/Logo_Navamin_1.ed4b19a0.png";